import alliance from './alliance';
import allianceNoDisclaimer from './allianceNoDisclaimer';
import airlineOneWay from './airlineOneWay';
import airlineOneWayBasic from './airlineOneWayBasic';
import airlineOneWayBiTones from './airlineOneWayBiTones';
import airlineOneWayNoDisclaimer from './airlineOneWayNoDisclaimer';
import airlineOneWayNoImage from './airlineOneWayNoImage';
import airlineOneWayThin from './airlineOneWayThin';
import airlineOneWayThinColumns from './airlineOneWayThinColumns';
import airlineOneWayWithButton from './airlineOneWayWithButton';
import airlineRoundTrip from './airlineRoundTrip';
import airlineRoundTripBasic from './airlineRoundTripBasic';
import airlineRoundTripBiTones from './airlineRoundTripBiTones';
import airlineRoundTripColumns from './airlineRoundTripColumns';
import airlineRoundTripNoDisclaimer from './airlineRoundTripNoDisclaimer';
import airlineRoundTripNoImage from './airlineRoundTripNoImage';
import airlineRoundTripOneLine from './airlineRoundTripOneLine';
import airlineWithButtonRoundTrip from './airlineWithButtonRoundTrip';
import roundedImage from './roundedImage';
import airlineRoundTripBasicDesktop from './airlineRoundTripBasicDesktop';
import airlineRoundTripWithImageDesktop from './airlineRoundTripWithImageDesktop';
import airlineRoundTripNoImageDesktop from './airlineRoundTripNoImageDesktop';
import airlineRoundTripBiTonesDesktop from './airlineRoundTripBiTonesDesktop';
import airlineRoundTripDesktop from './airlineRoundTripDesktop';
import airlineOneWayBasicDesktop from './airlineOneWayBasicDesktop';
import airlineOneWayDesktop from './airlineOneWayDesktop';
import airlineOneWayNoImageDesktop from './airlineOneWayNoImageDesktop';
import airlineOneWayBiTonesDesktop from './airlineOneWayBiTonesDesktop';
import fareItemCarousel from './fareItemCarousel';
import fareItemPopularDestinations from './fareItemPopularDestinations';
import biColorOneWay from './biColorOneWay';
import destinationImageOneWay from './destinationImageOneWay';
import fullCard from './fullCard';
import classicRoundTrip from './classicRoundTrip';
import essentialOneWay from './essentialOneWay';
import basicRoundTrip from './basicRoundTrip';
import fareItemFeaturedTopDestinations from './fareItemFeaturedTopDestinations';
import fareItemFeaturedDestinations from './fareItemFeaturedDestinations';
import fareItemFeaturedTopDestinationsMobile from './fareItemFeaturedTopDestinationsMobile';
import fareItemFeaturedDestinationsLight from './fareItemFeaturedDestinationsLight';
import roundtripRoundedImageSimple from './roundtripRoundedImageSimple';
import fareItemFeaturedDestinationsMobile from './fareItemFeaturedDestinationsMobile';

const flavors = {
  alliance,
  allianceNoDisclaimer,
  airlineOneWay,
  airlineOneWayBasic,
  airlineOneWayBiTones,
  airlineOneWayNoDisclaimer,
  airlineOneWayNoImage,
  airlineOneWayThin,
  airlineOneWayThinColumns,
  airlineOneWayWithButton,
  airlineRoundTrip,
  airlineRoundTripBasic,
  airlineRoundTripBiTones,
  airlineRoundTripColumns,
  airlineRoundTripNoDisclaimer,
  airlineRoundTripNoImage,
  airlineRoundTripOneLine,
  airlineWithButtonRoundTrip,
  roundedImage,
  airlineRoundTripBasicDesktop,
  airlineRoundTripWithImageDesktop,
  airlineRoundTripNoImageDesktop,
  airlineRoundTripBiTonesDesktop,
  airlineRoundTripDesktop,
  airlineOneWayBasicDesktop,
  airlineOneWayDesktop,
  airlineOneWayNoImageDesktop,
  airlineOneWayBiTonesDesktop,
  fareItemCarousel,
  fareItemPopularDestinations,
  biColorOneWay,
  destinationImageOneWay,
  fullCard,
  classicRoundTrip,
  essentialOneWay,
  basicRoundTrip,
  fareItemFeaturedTopDestinations,
  fareItemFeaturedDestinations,
  fareItemFeaturedTopDestinationsMobile,
  fareItemFeaturedDestinationsLight,
  roundtripRoundedImageSimple,
  fareItemFeaturedDestinationsMobile,
};

export default flavors;
